export class ZenodoFile {
    zenodo;
    value;
    constructor(zenodo, file) {
        this.value = file;
        this.zenodo = zenodo;
    }
    async getContentResponse() {
        const link = this.value.links.content;
        const response = await fetch(link, {
            headers: {
                Authorization: `Bearer ${this.zenodo.accessToken}`,
            },
        });
        if (!response.ok) {
            throw new Error(`Failed to fetch ${link}`);
        }
        return response;
    }
}
//# sourceMappingURL=ZenodoFile.js.map